<template>
  <div class="mt-3 ml-3 mr-3">
    <v-btn
      class="ml-6"
      fab
      color="#2722a6"
      v-b-modal.add-project
      v-b-tooltip.hover
      title="Click To Add"
    >
      <v-icon large color="white">mdi-plus</v-icon>
    </v-btn>
    <b-modal
      id="add-project"
      centered
      scrollable
      title="Project Form"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <add-project-form modalId="add-project" />
    </b-modal>
    <div style="display: flex; margin-top: 20px">
      <v-text-field
        v-model="projectNameFilter"
        placeholder="Filter by Project Name"
        type="text"
        background-color="white"
        color="red"
        solo
        @input="onProjectNameFilterChange"
      />

      <v-menu
        bottom
        min-width="400px"
        offset-y
        origin="center center"
        transition="scale-transition"
        v-model="menu"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{on, attrs}">
          <v-btn
            class="ml-6 white--text"
            large
            width="200"
            tile
            color="#2722a6"
            v-bind="attrs"
            v-on="on"
            v-b-tooltip.hover
            title="Click to Filter By Project Status"
          >
            Filter<v-spacer></v-spacer><v-icon>{{ "mdi-filter" }}</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-container>
            <v-form>
              <v-autocomplete
                :items="category"
                clearable
                deletable-chips
                label="Category"
                v-model="filterForm"
                multiple
                chips
                outlined
              ></v-autocomplete>
              <pre>{{ filterForm }}</pre>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  tile
                  color="green darken-1"
                  text
                  type="submit"
                  @click="onApply"
                >
                  Apply
                </v-btn>
                <v-btn tile color="green darken-1" text @click="menu = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-container>
        </v-card>
        <v-list color="#2722a6" tile dark>
          <v-list-item
            @click="filterByCategory(item.value)"
            type="button"
            v-for="(item, i) in category"
            :key="i"
          >
            {{ item.text }}
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn class="mt-1">{{ selectedCategory }}</v-btn>
      <v-spacer></v-spacer>
    </div>
    <div v-for="item in category" :key="item.text">
      <separator
        v-if="categorizedProjects[item.text].length !== 0"
        :separator_text="item.text"
      ></separator>
      <v-row justify="start" class="m-2">
        <v-col
          v-for="(project, index) in categorizedProjects[item.text]"
          :key="project.id"
          lg="3"
          md="6"
        >
          <div style="display: flex">
            <v-btn
              icon
              color="white"
              v-if="index > 0"
              @click="changePriority(item.text, index, -1)"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="white"
              v-if="index < categorizedProjects[item.text].length - 1"
              @click="changePriority(item.text, index, 1)"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>

          <project-top-card
            :project="project"
            :publishFlag="project.publish_website_flag"
            :key="project.id"
            v-on:child-to-parent-projects="onChildClick"
            modalId="project-detail"
            class="mx-auto"
            editModalId="edit-project-detail"
          />
        </v-col>
      </v-row>
    </div>
    <b-modal
      id="project-detail"
      :title="projectDetailModal.title"
      ok-only
      centered
      scrollable
      @hide="resetProjectDetailModal"
    >
      <view-project-detail :project-detail="projectDetailModal" />
    </b-modal>

    <b-modal
      id="edit-project-detail"
      :title="projectDetailModal.title"
      ok-only
      @hide="resetProjectDetailModal"
      hide-footer
      size="lg"
      scrollable
      centered
      no-close-on-backdrop
      no-close-on-esc
      body-class="p-0"
    >
      <edit-project-detail
        :project-detail="projectDetailModal"
        modal-id="edit-project-detail"
        @project-content-updated="projectContentUpdated"
      />
    </b-modal>
  </div>
</template>
<script>
import ProjectTopCard from "@/components/Projects/ProjectTopCard";
import ViewProjectDetail from "@/components/Projects/ViewProjectDetail";
import AddProjectForm from "@/components/Projects/AddProjectForm";
import EditProjectDetail from "@/components/Projects/EditProjectDetail";
import {mapActions, mapGetters} from "vuex";
import Separator from "@/components/Layout/Separator";
import {bus} from "@/main";

export default {
  name: "ViewProjects",
  components: {
    separator: Separator,
    "project-top-card": ProjectTopCard,
    "add-project-form": AddProjectForm,
    "view-project-detail": ViewProjectDetail,
    "edit-project-detail": EditProjectDetail,
  },
  data() {
    return {
      projectNameFilter: "",
      show: false,
      menu: false,
      projectDetailModal: {},
      name: "",
      nameState: null,
      submittedNames: [],
      category: [
        {text: "All", value: ""},
        {text: "In Progress", value: "In Progress"},
        {text: "In Discussion", value: "In Discussion"},
        {text: "Prototype", value: "Prototype"},
        {text: "Finalising", value: "Finalising"},
        {text: "In Contention", value: "In Contention"},
        {text: "Completed", value: "Completed"},
        {text: "On Hold", value: "On Hold"},
        {text: "Cancelled", value: "Cancelled"},
      ],
      categorizedProjects: {
        "In Progress": [],
        "In Discussion": [],
        Prototype: [],
        Finalising: [],
        "In Contention": [],
        Completed: [],
        "On Hold": [],
        Cancelled: [],
        All: [],
      },
      filterForm: "",
      selectedCategory: "All",
    };
  },
  mounted() {
    bus.on("projecttop-targetselected", ({projectId, targetId}) => {
      console.log("Show Build Target For " + projectId + " " + targetId);
    });

    this.loadContent("");
  },
  computed: {
    ...mapGetters(["getProjects", "getLanguages"]),
  },
  methods: {
    ...mapActions([
      "fetchProjectList",
      "fetchProjectCategory",
      "fetchProjectStatus",
      "fetchProjectPlatform",
      "fetchLanguage",
      "showLoadingProcess",
      "closeLoading",
    ]),
    changePriority(arrayIdentifier, atIndex, by) {
      this.categorizedProjects[arrayIdentifier][atIndex].project_priority += by;
      // TODO: Update on back
    },
    projectContentUpdated() {
      // Force the project list on screen to re-load
      this.onProjectNameFilterChange();
    },
    onProjectNameFilterChange() {
      for (const item in this.category) {
        this.separateProjectCardByCategory(
          this.category[item].text,
          this.projectNameFilter
        );
      }
    },
    onApply(evt) {
      evt.preventDefault();
      this.menu = false;
    },
    filterByCategory(category) {
      this.selectedCategory = category;
      if (category === "") {
        this.selectedCategory = "All";
      }
      this.loadContent(category);
    },
    groupProjects(projects, category, projectNameFilter) {
      return projects.filter((value) => {
        function projectNameIncludesFilterString() {
          const lcProjectName = value.project_name.toLowerCase();
          const lcFilter = projectNameFilter.toLowerCase();
          return lcProjectName.includes(lcFilter);
        }

        return (
          value.project_status === category &&
          (projectNameFilter === "" || projectNameIncludesFilterString())
        );
      });
    },

    separateProjectCardByCategory(category, projectNameFilter) {
      // TODO: this switch has identical cases??
      switch (category) {
        case "In Progress":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "In Discussion":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "Prototype":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "In Contention":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "Completed":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "On Hold":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "Cancelled":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        case "Finalising":
          this.categorizedProjects[category] = this.groupProjects(
            this.getProjects,
            category,
            projectNameFilter
          );
          break;
        default:
          break;
      }
    },

    async loadContent(category) {
      await this.showLoadingProcess();
      const filterQuery = `?project_status=${category}`;
      try {
        // noinspection ES6MissingAwait
        const requests = [
          this.fetchProjectPlatform(),
          this.fetchProjectStatus(),
          this.fetchProjectCategory(),
          this.fetchLanguage(),
          this.fetchProjectList(filterQuery),
        ];

        await Promise.all(requests);
        await this.closeLoading();

        for (const item in this.category) {
          this.separateProjectCardByCategory(
            this.category[item].text,
            this.projectNameFilter
          );
        }
      } catch (err) {
        await this.closeLoading();
        console.log(err);
      }
    },

    addProject(value) {
      this.projects = value;
      for (const item in this.category) {
        this.separateProjectCardByCategory(
          this.category[item].text,
          this.projectNameFilter
        );
      }
    },

    showProjectDetail(item, index, button) {
      this.projectDetailModal.title = `Row index: ${index}`;
      this.projectDetailModal.content = JSON.stringify(item, null, 2);
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("bv::show::modal", this.projectDetailModal.id, button);
    },

    resetProjectDetailModal() {
      this.projectDetailModal.title = "";
      this.projectDetailModal.content = "";
      window.onscroll = function () {}; // <==== enable scroll when modal is close
    },

    showDetail() {
      this.show = !this.show;
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },

    resetModal() {
      this.name = "";
      this.nameState = null;
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },

    onChildClick(value) {
      this.projectDetailModal = value;
      let x = window.scrollX; // <==== disable scroll when modal is open do not affect modal
      let y = window.scrollY;
      window.onscroll = function () {
        window.scrollTo(x, y);
      };
    },
  },
};
</script>
<style scoped></style>
